/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AiOfferBatchPendingCountResponse model module.
 * @module model/AiOfferBatchPendingCountResponse
 * @version 1.0.0
 */
class AiOfferBatchPendingCountResponse {
    /**
     * Constructs a new <code>AiOfferBatchPendingCountResponse</code>.
     * @alias module:model/AiOfferBatchPendingCountResponse
     */
    constructor() { 
        
        AiOfferBatchPendingCountResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AiOfferBatchPendingCountResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AiOfferBatchPendingCountResponse} obj Optional instance to populate.
     * @return {module:model/AiOfferBatchPendingCountResponse} The populated <code>AiOfferBatchPendingCountResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AiOfferBatchPendingCountResponse();

            if (data.hasOwnProperty('pending_count')) {
                obj['pending_count'] = ApiClient.convertToType(data['pending_count'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AiOfferBatchPendingCountResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AiOfferBatchPendingCountResponse</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * 未処理（generating / ready）のバッチ数
 * @member {Number} pending_count
 */
AiOfferBatchPendingCountResponse.prototype['pending_count'] = undefined;






export default AiOfferBatchPendingCountResponse;

